<template>
    <ui-card-accordeon
        :items="cardsTitles"
        @progress="progress = $event"
    >
        <template v-slot:prepend-0>
            <slot name="title" />
        </template>
        <template
            v-for="(card, i) in cards"
            v-slot:[`card-${card.id}`]
        >
            <div
                :id="'premium-card-accordeon__' + card.id"
                :key="card.id"
                class="premium-card-accordeon__card"
                :style="{
                    '--premium-card-accordeon-c-img': card.image ? `url(/local/templates/redesign/src/assets/img/premium/premium-card-accordeon/${card.image}.webp)` : '',
                    '--premium-card-accordeon-c-bg': getBg[i],
                }"
            >
                <div class="premium-card-accordeon__card-content _ml-56-16 _pr-0-16 _dflex _flexdir-column">
                    <div class="premium-card-accordeon__card-title h2-h3m">
                        {{ card.title }}
                    </div>
                    <div
                        class="_dgrid _gap-24-16"
                        :class="{
                            [card.cols ? `_grid-cols-${card.cols}-1` : '_grid-cols-2-1']: true,
                        }"
                    >
                        <div
                            v-for="(item, ii) in card.items"
                            :key="ii"
                        >
                            <div class="_dflex">
                                <div class="icon icon-check_premium icon_size-32" />
                                <div class="_ml-8 _mt-0-8">
                                    <div v-if="item.title" class="h4 white-text _mb-8-0">{{ item.title }}</div>
                                    <span :class="{'_tooltip-inline-group': item.tooltip}">
                                        <p v-if="item.subtitle" class="p1-p2m white-text _mt-8-0" v-html="item.subtitle"></p>
                                        <tooltip v-if="item.tooltip" :text="item.tooltip" icon="info" color="white"></tooltip>
                                    </span>
                                </div>
                            </div>
                            <p v-if="item.content" class="p1-p2m white-text _ml-0-40">
                                {{ item.content }}
                            </p>
                        </div>
                    </div>
                    <div class=" _mt-auto _mb-56-24">
                        <a class="button button_white" :href="card.action.href">{{ card.action.title }}</a>
                    </div>
                </div>
            </div>
        </template>
    </ui-card-accordeon>
</template>
<script>
import UiCardAccordeon from '../ui/UiCardAccordeon.vue';

export default {
    name: 'PremiumCardAccordeon',
    components: {
        UiCardAccordeon,
    },
    data() {
        return {
            cards: [
                {
                    id: 0,
                    head: 'Расширяйте финансовые возможности',
                    title: 'Предлагаем выгодные условия',
                    image: 'profit',
                    cols: 2,
                    items: [
                        {
                            title: 'до ' + window.config.deposit_rates.premium + '%',
                            content: 'ставка по вкладу',
                        },
                        {
                            title: '5%',
                            content: 'годовых на остаток по карте в рублях',
                        },
                        {
                            title: `до 750 тыс. ₽`,
                            content: 'лимит по кредитной карте Mir Supreme',
                        },
                        {
                            title: 'Счет в драгметаллах',
                            content: 'получайте доход за счет роста стоимости золота и серебра',
                        },

                    ],
                    action: {
                        title: 'Больше про привилегии',
                        href: '/premium/capital/',
                    },
                },
                {
                    id: 1,
                    head: 'Путешествуйте с комфортом',
                    title: 'Помогаем в путешествии',
                    image: 'voyage',
                    cols: 3,
                    items: [
                        {
                            title: '',
                            subtitle: 'Доступ в&nbsp;бизнес-залы с&nbsp;Mir Pass'
                        },
                        {
                            title: '',
                            subtitle: 'Страхование на&nbsp;время путешествия',
                        },
                        {
                            title: '',
                            subtitle: 'Компенсация поездок на&nbsp;такси'
                        },
                    ],
                    action: {
                        title: 'Больше про привилегии',
                        href: '/premium/travel/',
                    },
                },
                {
                    id: 2,
                    head: 'Живите без забот',
                    title: 'Решаем ваши задачи',
                    image: 'solvings',
                    cols: 3,
                    items: [
                        {
                            title: '',
                            subtitle: 'Консьерж-сервис 24/7',
                        },
                        {
                            title: '',
                            subtitle: 'Консультация юриста 24/7',
                        },
                        {
                            title: '',
                            subtitle: 'Подбор недвижимости',
                        },
                    ],
                    action: {
                        title: 'Больше про привилегии',
                        href: '/premium/life/',
                    },
                },
                {
                    id: 3,
                    head: 'С заботой о здоровье',
                    title: 'Ваше здоровье - наш приоритет',
                    image: 'health',
                    cols: 3,
                    items: [
                        {
                            title: '',
                            subtitle: 'Чекап&nbsp;обследование',
                            tooltip: 'Доступно для клиентов с уровнем привилегий «Ультра»'
                        },
                    ],
                    action: {
                        title: 'Больше про привилегии',
                        href: '/premium/health/',
                    },
                },
            ],
            progress: [],
            bg: ['#1F4A51', '#19393A'],
        };
    },
    computed: {
        cardsTitles() {
            return this.cards.map((item) => ({
                title: item.head,
                value: item.id,
            }));
        },
        getBg() {
            const countActive = this.progress.filter((item) => item > 0).length;
            return this.cards.map((c, i) => {
                return this.progress[i] > 0 ? (countActive === 1 ? this.bg[1] : this.bg[Math.min(1, i)]) : '';
            });
        },
    },
};
</script>
<style lang="scss">
@import '../../assets/scss/base/variables';
@import '../../assets/scss/base/functions';
@import '../../assets/scss/base/mixins';

$accent-color: $green-premium;

.premium-card-accordeon {
    &__card {
        @include fluid('--premium-card-accordeon-c-min-h', 516px, 620px);
        @include fluid('--premium-card-accordeon-c-br', 56px, 24px);
        @include fluid('--premium-card-accordeon-c-mt', 88px, 80px);
        border-radius: var(--premium-card-accordeon-c-br);
        position: relative;
        --premium-card-accordeon-c-bg: #252628;

        margin-top: calc(var(--premium-card-accordeon-c-mt) * -1);
        box-shadow: -1px -1px 0 0 rgba($white-101, 0.5);
        height: var(--premium-card-accordeon-c-min-h);
        background:var(--premium-card-accordeon-c-bg);
        transition: background .3s;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: var(--premium-card-accordeon-c-br);
            background: bottom right / auto var(--premium-card-accordeon-c-min-h) no-repeat var(--premium-card-accordeon-c-img);

            @include mobile {
                background: bottom center / 110% auto no-repeat var(--premium-card-accordeon-c-img);
            }
        }

        &-content {
            padding-top: var(--premium-card-accordeon-c-mt);
            height: 100%;
            position: relative;

            @include not-mobile {
                @include fluid('width', 591px);
            }
        }

        &-title {
            color: $accent-color;
            @include fluid('margin-top', 24px, 8px);
            @include fluid('margin-bottom', 24px, 24px);
        }
    }



}
</style>
